export default {
    shippings: {},
    shippingMethod: null,
    loadingCalculate: false,
    pendingRequests: 0,
    cepDestination: null
}
  